import { ReactText } from "react"

export function displayPartPosition(links: boolean, rechts: boolean, callbackTranslate: (key: ReactText) => string) {
    const buttonTitle = links && rechts ? callbackTranslate(1809) : links ? callbackTranslate(355) : rechts ? callbackTranslate(356) : ""

    return buttonTitle
}
